<template>
    <div class="ion-text-start ion-padding">
        <page-header :title="$t('privacyPolicy.header')" />
        <p>{{ $t('privacyPolicy.headerP1') }}</p>
        <p>{{ $t('privacyPolicy.headerP2') }}</p>
        <h1>{{ $t('privacyPolicy.overview') }}</h1>
        <p>{{ $t('privacyPolicy.overviewP1') }}</p>
        <p>{{ $t('privacyPolicy.overviewP2') }}</p>
        <h1>{{ $t('privacyPolicy.section1Title') }}</h1>
        <p>{{ $t('privacyPolicy.section1P1') }}</p>
        <h1>{{ $t('privacyPolicy.section2Title') }}</h1>
        <p>{{ $t('privacyPolicy.section2P1') }}</p>
        <p>{{ $t('privacyPolicy.section2P2') }}</p>
        <p>{{ $t('privacyPolicy.section2P3') }}</p>
        <h1>{{ $t('privacyPolicy.section3Title') }}</h1>
        <p>{{ $t('privacyPolicy.section3P1') }}</p>
        <p>{{ $t('privacyPolicy.section3P2') }}</p>
        <p>{{ $t('privacyPolicy.section3P3') }}</p>
        <h1>{{ $t('privacyPolicy.section4Title') }}</h1>
        <p>{{ $t('privacyPolicy.section4P1') }}</p>
        <p>{{ $t('privacyPolicy.section4P2') }}</p>
        <h5>{{ $t('privacyPolicy.section4Sub1') }}</h5>
        <p>{{ $t('privacyPolicy.section4P3') }}</p>
        <h5>{{ $t('privacyPolicy.section4Sub2') }}</h5>
        <p>{{ $t('privacyPolicy.section4P4') }}</p>
        <h5>{{ $t('privacyPolicy.section4Sub3') }}</h5>
        <p>{{ $t('privacyPolicy.section4P5') }}</p>
        <h5>{{ $t('privacyPolicy.section4Sub4') }}</h5>
        <p>{{ $t('privacyPolicy.section4P6') }}</p>
        <h1>{{ $t('privacyPolicy.section5Title') }}</h1>
        <p>{{ $t('privacyPolicy.section5P1') }}</p>
        <h1>{{ $t('privacyPolicy.section6Title') }}</h1>
        <p>{{ $t('privacyPolicy.section6P1') }}</p>
        <p>{{ $t('privacyPolicy.section6P2') }}</p>
        <p>{{ $t('privacyPolicy.section6P3') }}</p>
        <h1>{{ $t('privacyPolicy.section7Title') }}</h1>
        <p>{{ $t('privacyPolicy.section7P1') }}</p>
        <h1>{{ $t('privacyPolicy.section8Title') }}</h1>
        <p>{{ $t('privacyPolicy.section8P1') }}</p>
        <h1>{{ $t('privacyPolicy.section9Title') }}</h1>
        <p>{{ $t('privacyPolicy.section9P1') }}</p>
        <h1>{{ $t('privacyPolicy.section10Title') }}</h1>
        <p>{{ $t('privacyPolicy.section10P1') }}</p>
        <h1>{{ $t('privacyPolicy.section11Title') }}</h1>
        <p>{{ $t('privacyPolicy.section11P1') }}</p>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'

export default {
    name: 'PrivacyPolicy',
    components: { PageHeader }
}
</script>
